import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const Overview = () => {
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const payments = booking.payment;
  const { t } = useTranslation();

  return (
    <>
      <div className="col-12 col-lg-4">
        <p>
          <strong>
            {t("bookingDetails.payments.travelPrice")}: {payments.totalPrice}
          </strong>
        </p>
      </div>
      {/* <div className="col-12 col-lg-4">
        {!isAgency ? (
          <p>
            <strong>
              {" "}
              {t("bookingDetails.payments.paid")}: {payments.totalPayment}
            </strong>
          </p>
        ) : null}
      </div>
      <div className="col-12 col-lg-4">
        {!isAgency ? (
          <p>
            <strong>
              {" "}
              {t("bookingDetails.payments.paid")}: {payments.openAmount}
            </strong>
          </p>
        ) : null}
      </div> */}
    </>
  );
};

export default Overview;
